import React, { Component } from "react";
import { withFirebase } from "../Firebase/Firebase";
import TwoColumns from "../TwoColumns/TwoColumns";
import Button from "../Button/Button";
import moment from "moment";
import "./EntryItem.css";

class EntryItem extends Component {
	
	constructor(props) {
		super();
		
	}

	generateDownloadLink = async location => {
		const link = await this.props.methods.getFileUrl(location);
		// console.log('link',link);
		window.open(link,'_blank');
	};
	render() {
		
		let complete = this.props.entry.stage >= 5;
		
		if (this.props.expanded) {
			return (
				<div className="entry-item">
				<div className="heading">
				<h3>{this.props.entry.title}{" "}</h3>
				{!complete && <p><span className="tag">Incomplete</span></p>}
				</div>
				<TwoColumns
				left={
					<div>
					<label>Name</label>
					<div className="value">{this.props.entry.entry_first_name} {this.props.entry.entry_last_name}</div>
					<label>Email</label>
					<div className="value">{this.props.entry.entry_email}</div>
					<label>Mobile</label>
					<div className="value">{this.props.entry.entry_mobile}</div>

					<label>State</label>
					<div className="value">{this.props.entry.state}</div>
					<label>Social Issue</label>
					<div className="value">{this.props.entry.issue}</div>
					<label>Number of members in your film-making team (max 6)</label>
					<div className="value">
					{this.props.entry.numberOfMembersInYourTeam}
					</div>
					<label>Please enter full names of all team members, separating each name with a comma</label>
					<div className="value">
					{this.props.entry.fullNamesOfAllTeamMembers}
					</div>
					<label>Please enter full names of any other people who appear in your video (talent), separating each name with a comma</label>
					<div className="value">
					{this.props.entry.fullNamesOfAnyOtherPeopleWhoAppearInYourVideo}
					</div>
					</div>
				}
				right={
					<div>

					{this.props.entry.created && <div>
						<label>Entry Date</label>
						{moment(this.props.entry.created).zone('+1000').format("Do MMMM YYYY, h:mm:ss a")}
					</div>}

					{this.props.entryId && <div><label>Video File</label>
					<strong>{this.props.entryId.split(/[-]+/).pop()}</strong></div>}


					{this.props.entryId && <div><label>Video File</label>
					<a className="button -small" href={`https://console.firebase.google.com/u/0/project/videosforchange-production/database/videosforchange-production/data/entries/${this.props.entryId}`} target="_blank"> Firebase Entry</a></div>}

					<label>How did you hear about Videos for Change?</label>
					<div className="value">
					{this.props.entry.howYouHeardAboutVideosForChange}
					</div>
					<label>
					Was there a teacher that supported you?
					</label>
					<div className="value">
					{this.props.entry.teacher}
					</div>
					<label>School or Youth Group Name</label>
					<div className="value">
					{this.props.entry.schoolOrYouthName}
					</div>
					<label>Teacher first name</label>
					<div className="value">
					{this.props.entry.teacherFirstName}
					</div>
					<label>Teacher Last Name</label>
					<div className="value">
					{this.props.entry.teacherLastName}
					</div>
					<label>Teacher email</label>
					<div className="value">
					{this.props.entry.teacherEmailAddress}
					</div>
					<label>School Grade of Oldest Team Member</label>
					<div className="value">
					{this.props.entry.grade}
					</div>
					</div>
					
				}
				/>
				{this.props.entry.members &&
					<div className="members">
					{Object.keys(this.props.entry.members).map(memberId => {
						const member = this.props.entry.members[memberId];
						return (
							<div className="member" key={memberId}>
							<div className="heading">
							<h5>Team Member</h5>
							<h3>{member.firstName} {member.lastName}</h3>
							</div>
							<TwoColumns
							left={
								<div>
								<label>Gender</label>
								<div className="value">{member.gender}</div>
								<label>Email address</label>
								<div className="value">
								{member.emailAddress}
								</div>
								<label>Date of birth</label>
								<div className="value">
								{member.dateOfBirth}
								</div>
								</div>
							}
							right={
								<div>
								<label>School Name</label>
								<div className="value">
								{member.schoolName}
								</div>
								<label>Mobile Number</label>
								<div className="value">
								{member.mobileNumber}
								</div>
								<label>Consent Form</label>
								<div className="value">
								{member.consentForm && <Button
								type="small"
								onClick={() =>
									this.generateDownloadLink(member.consentForm)
								}
								>
								Download
								</Button>}
								</div>
								</div>
							}
							/>
							</div>
						);
					})}
					</div>}
					
					{this.props.entry.talent &&
					<div className="members">
					{Object.keys(this.props.entry.talent).map(memberId => {
						const member = this.props.entry.talent[memberId];
						return (
							<div className="member -talent" key={memberId}>
								<div className="heading">
								<h5>Talent</h5>
								<h3>{member.firstName} {member.lastName}</h3>
								</div>
								<TwoColumns
							left={
								<div>
								<label>Email address</label>
								<div className="value">
								{member.emailAddress}
								</div>
								<label>Age</label>
								<div className="value">
								{member.age}
								</div>
								</div>
							}
							right={
								<div>
								<label>Mobile Number</label>
								<div className="value">
								{member.mobileNumber}
								</div>
								<label>Talent Release</label>
								<div className="value">
								{member.releaseForm && <Button
								type="small"
								onClick={() =>
									this.generateDownloadLink(member.releaseForm)
								}
								>
								Download
								</Button>}
								</div>
								</div>
							}
							/>
							</div>
						);
					})}
					</div>}
					{complete && <Button type="primary" onClick={this.props.saveAsVideo}>Add to Videos</Button>}
					</div>
				);
			}
			return (
				<div
				className={
					this.props.entry.stage >= 5
					? "entry-item"
					: "entry-item -incomplete"
				}
				>
				<div className="description">
				<h3>{this.props.entry.title ? this.props.entry.title : 'New Entry'}</h3>
				{this.props.entry.stage < 5 && <p><span className="tag">Incomplete</span></p>}
				</div>
				<div className="action">
				<a href="/" onClick={this.props.setExpanded}>
				View
				</a>
				</div>
				</div>
			);
		}
	}
	
	export default withFirebase(EntryItem);
	


// WEBPACK FOOTER //
// ./src/components/EntryItem/EntryItem.js